export function PaidNonAdvisoryClientRIA() {
  return (
    <p className="typography-text-extra-small text-muted-foreground">
      Paid non-advisory client promotion. NerdWallet maintains a 401k program and equity management
      program through affiliates of this provider; NerdWallet doesn&apos;t invest its money with
      this provider, but they are our referral partner - so we get paid only if you click through
      and take a qualifying action. Being a referral partner influences which products we write
      about and where and how the product appears on our webpage. Most importantly, however, the
      content of our reviews and ratings are objective and are never impacted by our partnerships.
      Our opinions are our own. Here is a{' '}
      <a href="https://www.nerdwallet.com/p/our-partners" className="underline">
        list of our partners
      </a>{' '}
      and{' '}
      <a href="https://www.nerdwallet.com/p/advertiser-disclosure" className="underline">
        here&rsquo;s how we make money
      </a>
      .
    </p>
  );
}
